import React from 'react';
import { BarChart3 } from 'lucide-react';

const AllTimeStandingsBanner = () => {
  return (
    <div className="relative bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 rounded-2xl shadow-xl overflow-hidden min-h-[200px]">
      {/* Background Images - Full Coverage */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Mobile: Single image covering more area */}
        <div className="block lg:hidden absolute inset-0 flex items-center justify-center">
          <img 
            src="/beastladder.png"
            alt="Beast Ladder Rankings"
            className="w-[85%] h-[85%] object-cover opacity-25"
            style={{ 
              objectPosition: 'center center',
              maskImage: 'radial-gradient(ellipse at center, black 50%, transparent 85%)',
              WebkitMaskImage: 'radial-gradient(ellipse at center, black 50%, transparent 85%)'
            }}
          />
        </div>

        {/* Desktop: Left Beast Image - Background */}
        <div className="hidden lg:block absolute left-0 top-0 w-1/2 h-full flex items-center justify-end">
          <img 
            src="/beastladder.png" 
            alt="Beast Ladder Rankings" 
            className="w-[70%] h-full object-cover opacity-20"
            style={{ 
              objectPosition: 'right center',
              maskImage: 'linear-gradient(to right, black 0%, black 60%, transparent 100%)',
              WebkitMaskImage: 'linear-gradient(to right, black 0%, black 60%, transparent 100%)'
            }}
          />
        </div>

        {/* Desktop: Right Beast Image - Background, Flipped */}
        <div className="hidden lg:block absolute right-0 top-0 w-1/2 h-full flex items-center justify-start">
          <img 
            src="/beastladder.png" 
            alt="Beast Ladder Rankings" 
            className="w-[70%] h-full object-cover opacity-20"
            style={{ 
              objectPosition: 'left center',
              transform: 'scaleX(-1)',
              maskImage: 'linear-gradient(to left, black 0%, black 60%, transparent 100%)',
              WebkitMaskImage: 'linear-gradient(to left, black 0%, black 60%, transparent 100%)'
            }}
          />
        </div>
      </div>

      {/* Enhanced Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-1/4 w-32 h-32 bg-white/5 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-20 right-1/4 w-24 h-24 bg-yellow-400/10 rounded-full blur-lg animate-bounce"></div>
        <div className="absolute top-1/3 right-1/3 w-16 h-16 bg-blue-400/10 rounded-full blur-md animate-pulse delay-300"></div>
        
        {/* Additional Floating Particles */}
        <div className="absolute top-10 right-10 w-6 h-6 bg-orange-400/30 rounded-full animate-bounce delay-500"></div>
        <div className="absolute bottom-10 left-20 w-4 h-4 bg-yellow-400/40 rounded-full animate-ping"></div>
        <div className="absolute top-1/2 left-10 w-8 h-8 bg-red-400/20 rounded-full animate-pulse delay-700"></div>
        <div className="absolute bottom-1/3 right-1/2 w-5 h-5 bg-amber-400/35 rounded-full animate-bounce delay-1000"></div>
      </div>

      {/* Foreground Text Content */}
      <div className="relative z-10 p-8 flex items-center justify-center min-h-[200px]">
        <div className="text-center">
          <h1 className="text-4xl lg:text-5xl font-black text-white mb-2 tracking-tight drop-shadow-lg">
            All-Time Standings
          </h1>
          <p className="text-blue-100 text-lg lg:text-xl font-medium drop-shadow-md">
            Complete historical performance and head-to-head records
          </p>
        </div>
      </div>
    </div>
  );
};

export default AllTimeStandingsBanner;